import { inject } from '@/config/injections.ts';
import { CONFIG } from '@/config/ConfigKeys.ts';

export { type AuthenticationConfig, configSchema, type Config } from './ConfigSchema.ts';
export { provideConfig } from './ConfigProvider.ts';

export const config = () => inject(CONFIG);
